import React from 'react';
import { Editor } from 'slate';
import { AulaPlugin } from '../plugins';
import { RichTextCommand } from './types';
import { richTextCommands, textColourCommand } from './config';
import { matchesHotkey } from '../../lib/hotkeys';
import { RichTextMark } from '../../types';

// rich text key type guard
export const isRichTextMark = (key: string | number): key is RichTextMark =>
  richTextCommands.find((command) => command.richTextMark === key) !==
  undefined;

export const richtext: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  onKeyDown: (e) => {
    if (editableProps.onKeyDown) editableProps.onKeyDown(e);

    const hotkeyCommand = richTextCommands.find((command) =>
      command.hotkeys.some((hotkey) => matchesHotkey(hotkey, e))
    );

    if (!hotkeyCommand || hotkeyCommand === textColourCommand) {
      return;
    }

    // ensure we prevent default behaviour when hotkey is matched
    e.preventDefault();

    const marks = Editor.marks(editor);

    if (marks != null && marks[hotkeyCommand.richTextMark] != null) {
      Editor.removeMark(editor, hotkeyCommand.richTextMark);
    } else {
      Editor.addMark(editor, hotkeyCommand.richTextMark, true);
    }
  },
  renderLeaf: (props) => {
    const { children, leaf } = props;
    const activeMarks = Object.keys(leaf).filter(isRichTextMark);

    if (activeMarks.length === 0 && editableProps.renderLeaf) {
      return editableProps.renderLeaf(props);
    }

    return activeMarks.reduce((content, mark) => {
      const richTextCommand = richTextCommands.find(
        (command) => command.richTextMark === mark
      ) as RichTextCommand;
      const Mark = richTextCommand.renderLeaf;
      return <Mark {...props}>{content}</Mark>;
    }, children);
  },
});
